"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BETCustomerSummaryTab = exports.BETRenewalSummaryTab = void 0;

var _react = _interopRequireDefault(require("react"));

var _TimelinePermissions = require("crm_ui/BET/permissions/TimelinePermissions");

var _CustomerSummaryContainerAsync = _interopRequireDefault(require("crm_ui/BET/timeline/CustomerSummaryContainerAsync"));

var _RenewalSummaryContainerAsync = _interopRequireDefault(require("crm_ui/BET/timeline/RenewalSummaryContainerAsync"));

var _TimelineConstants = require("crm_ui/BET/timeline/TimelineConstants");

var _loggers = require("customer-data-tracking/loggers");

var BETRenewalSummaryTab = function BETRenewalSummaryTab(_ref) {
  var tabRenderer = _ref.tabRenderer,
      subject = _ref.subject,
      objectType = _ref.objectType;

  if (!(0, _TimelinePermissions.canRenderRenewalSummaryTab)({
    subject: subject,
    objectType: objectType
  })) {
    return null;
  }

  var renewalSummaryContainerAsync = _react.default.createElement(_RenewalSummaryContainerAsync.default, {
    deal: subject
  });

  return tabRenderer(_TimelineConstants.BET_RENEWAL_SUMMARY_TAB, _TimelineConstants.BET_RENEWAL_SUMMARY_TAB, renewalSummaryContainerAsync);
};

exports.BETRenewalSummaryTab = BETRenewalSummaryTab;

var BETCustomerSummaryTab = function BETCustomerSummaryTab(_ref2) {
  var tabRenderer = _ref2.tabRenderer,
      subject = _ref2.subject,
      objectType = _ref2.objectType,
      BETDidCloseYourDealModalShow = _ref2.BETDidCloseYourDealModalShow,
      handleBETCloseYourDealModalShown = _ref2.handleBETCloseYourDealModalShown;

  if (!(0, _TimelinePermissions.canRenderCustomerSummaryTab)({
    objectType: objectType,
    subject: subject
  })) {
    return null;
  }

  var customerSummaryContainerAsync = _react.default.createElement(_CustomerSummaryContainerAsync.default, {
    subject: subject,
    objectType: objectType,
    logTrackingEvent: _loggers.CrmLogger.logForBizOps,
    didCloseYourDealModalShow: BETDidCloseYourDealModalShow,
    handleCloseYourDealModal: handleBETCloseYourDealModalShown
  });

  return tabRenderer(_TimelineConstants.BET_CUSTOMER_SUMMARY_TAB, _TimelineConstants.BET_CUSTOMER_SUMMARY_TAB, customerSummaryContainerAsync);
};

exports.BETCustomerSummaryTab = BETCustomerSummaryTab;